// @flow
const CREDIT_CARD_URL = '/app/settings/billing?section=card';

function redirectToNewCheckout(routeTo, currentUrl) {
  routeTo(currentUrl.replace('/app/billing/plans', '/app/checkout'), {
    replace: true,
    exit: true,
  });
}

function redirectToNewPricing(routeTo, currentUrl) {
  routeTo(currentUrl.replace('/app/billing/plans', '/app/planbuilder/plans'), {
    replace: true,
    exit: true,
  });
}

function redirectToPricingPage(routeTo) {
  routeTo('/app/planbuilder/plans', {
    replace: true,
    exit: true,
  });
}

const asyncRoute = {
  routes: {
    card: {
      // $FlowFixMe
      onEnter({ routeTo }) {
        routeTo(CREDIT_CARD_URL, { replace: true });
      },
    },
    plans: {
      routes: {
        '.': {
          // $FlowFixMe
          onEnter({ routeTo, router }) {
            redirectToNewPricing(routeTo, router.next.url);
          },
        },
        'create-new-account': {
          // $FlowFixMe
          onEnter({ routeTo, router }) {
            redirectToNewCheckout(routeTo, router.next.url);
          },
        },
        'downgrade-team/:fromPlanName/:toPlanName/:interval': {
          onEnter({ routeTo }) {
            redirectToPricingPage(routeTo);
          },
        },
        'upgrade-to-team': {
          // $FlowFixMe
          onEnter({ routeTo, router }) {
            redirectToNewCheckout(routeTo, router.next.url);
          },
        },
        ':changeType/:toPlanName': {
          // $FlowFixMe
          onEnter({ routeTo, router }) {
            redirectToNewCheckout(routeTo, router.next.url);
          },
        },
        ':changeType/:fromPlanName/:toPlanName': {
          // $FlowFixMe
          onEnter({ routeTo, router }) {
            redirectToNewCheckout(routeTo, router.next.url);
          },
        },

        'downgrade-plan/:fromPlanName/:toPlanName/:interval': {
          onEnter({ routeTo }) {
            redirectToPricingPage(routeTo);
          },
        },
        'downgrade-survey/:fromPlanName/:toPlanName/:interval': {
          onEnter({ routeTo }) {
            redirectToPricingPage(routeTo);
          },
        },
      },
    },
  },
};

export default asyncRoute;
